import React, { useState } from 'react';
import { projectMilestoneServices } from '../../../APIServices/projectMilestoneServices';
import { useToast } from '../../../hooks/useToast';

function DeleteProjectMilestone({ getProjectMilestoneData, getDeletedProjectMilestoneData, setModalOpen, projectMilestoneData }) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);

  const softDeleteRestoreProjectMilestone = async () => {
    setButtonLoader(true);
    try {
      const data = await projectMilestoneServices.softDeleteRestoreProjectMilestone({
        id: projectMilestoneData?._id,
        type: 'delete',
      });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Project milestone deleted successfully.', 'ok');
        getProjectMilestoneData();
        getDeletedProjectMilestoneData();
        setModalOpen('');
      } else {
        toast(data?.customMessage || 'Unable to delete project milestone.', 'warn');
      }
    } catch (error) {
      toast('Unable to delete project milestone. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Delete Project Milestone</div>
            <div className="xs muted">Delete project milestone details</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-foot">
          <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
          <button
            className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
            onClick={softDeleteRestoreProjectMilestone}
            disabled={buttonLoader}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Deleting...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Yes, Delete It!</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteProjectMilestone;
